import { useNavigate, useLocation } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { decodeEntities } from '../lib/decodeEntities'

export default function MatureContentGate({ story, onConfirm }) {
  const navigate = useNavigate()
  const location = useLocation()
  const { user, profile } = useAuth()

  if (!user) {
    return (
      <div className="mature-gate">
        <div className="mature-gate__card">
          <div className="mature-gate__badge">18+</div>
          <h2 className="mature-gate__title">Sign in required</h2>
          <p className="mature-gate__story-title">"{decodeEntities(story.title)}"</p>
          <p className="mature-gate__desc">
            This story is rated <strong>Mature (18+)</strong>. You must be signed in to view mature content.
          </p>
          <div className="mature-gate__actions">
            <button className="btn btn-primary" onClick={() => navigate('/login?reason=login_required', { state: { from: location.pathname } })}>
              Sign in
            </button>
            <button className="btn btn-outline" onClick={() => navigate(-1)}>
              Go back
            </button>
          </div>
        </div>
      </div>
    )
  }

  // PR 2: fail-CLOSED on missing profile. Show the teen-blocked card until
  // the profile resolves, rather than briefly flashing the adult confirmation
  // dialog to a user whose profile hasn't loaded. profile.accountType comes
  // from profiles.account_type (server-authoritative, migration 127).
  const isTeenOrUnknown = !profile || profile.accountType !== 'adult'

  if (isTeenOrUnknown) {
    return (
      <div className="mature-gate">
        <div className="mature-gate__card">
          <div className="mature-gate__icon">🔒</div>
          <h2 className="mature-gate__title">Content not available</h2>
          <p className="mature-gate__desc">
            This story is rated <strong>Mature (18+)</strong> and is not available for teen accounts.
          </p>
          <p className="mature-gate__subdesc">
            If you believe your account age is incorrect, please contact{' '}
            <a href="mailto:support@versesite.com" className="mature-gate__link">support@versesite.com</a>.
          </p>
          <div className="mature-gate__actions">
            <button className="btn btn-outline" onClick={() => navigate(-1)}>
              Go back
            </button>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="mature-gate">
      <div className="mature-gate__card">
        <div className="mature-gate__badge">18+</div>
        <h2 className="mature-gate__title">Mature content</h2>
        <p className="mature-gate__story-title">"{story.title}"</p>
        <p className="mature-gate__desc">
          This story contains mature content rated <strong>18+</strong>. It may include adult themes, violence, or explicit content not suitable for all audiences.
        </p>
        <p className="mature-gate__subdesc">
          By continuing, you confirm that you are 18 years of age or older and consent to viewing this content.
        </p>
        <div className="mature-gate__actions">
          <button className="btn btn-primary" onClick={onConfirm}>
            I confirm I am 18 or older — Show story
          </button>
          <button className="btn btn-outline" onClick={() => navigate(-1)}>
            Go back
          </button>
        </div>
      </div>
    </div>
  )
}
